import { createContext } from "react";
import { ISeason } from 'predictagram-lib';

export interface ISeasonContext {
  season: ISeason | null
}

export const SeasonContext = createContext<ISeasonContext | null>(null);
